import { render } from "./evaLessonScale.vue?vue&type=template&id=4e193332&scoped=true"
import script from "./evaLessonScale.vue?vue&type=script&lang=js"
export * from "./evaLessonScale.vue?vue&type=script&lang=js"

import "./evaLessonScale.vue?vue&type=style&index=0&id=4e193332&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e193332"]])

export default __exports__